@if (loadingService.data) {
<div
	class="content-alert fullscreen vertical-align"
	[@openClose]="loadingService.data && loadingService.data._show ? 'open' : 'closed'"
>
	<div class="content text-center">
		@if (loadingService.data.header) {
		<p class="fs-26 f-bold">{{ loadingService.data.header }}</p>
		}
		<div class="spinner-border text-primary" role="status"></div>
		@if (loadingService.data.button) {
		<p (click)="close()" role="button" class="fs-16 text-secondary">
			{{ loadingService.data.button }}
		</p>
		}
	</div>
</div>
}
